module.exports = __webpack_public_path__ + "static/media/Flowers and gift delivery.97ae0879.png";